import { render, staticRenderFns } from "./packingWorkPg.vue?vue&type=template&id=1333f106&scoped=true"
import script from "./packingWorkPg.vue?vue&type=script&lang=js"
export * from "./packingWorkPg.vue?vue&type=script&lang=js"
import style0 from "./packingWorkPg.vue?vue&type=style&index=0&id=1333f106&prod&lang=less&scoped=true"
import style1 from "./packingWorkPg.vue?vue&type=style&index=1&id=1333f106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333f106",
  null
  
)

export default component.exports